export default __webpack_public_path__ + "static/media/enki.cded6f12.png";